//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamGrafDefinice.ts						</Name>
//    <Description> Dialog seznam licencí										</Description>
//    <Author>      thazmuka													</Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019							</Copyright>
//    <Created>     2019-02-20													</Created>
//  </FileHeader>

// experiment se seznamovým oknem, které pro vybudování využívá rodicovské třídy
// SeznamGrafDefiniceDesigner - strojně generovaná třída, která hlavně bude definovat políčka filtru a sloupce seznamu
// SeznamBase - obecný rodic včech seznamových oken

namespace Gordic.Adm.WebControls {

	const { gcontent } = Decorators;

	/** dialog seznamu licencí */
	@gcontent
    export class SeznamGrafDefinice extends GContentBase<SeznamGrafDefiniceDesigner>  {

		//#region *** onContentReady && Init ***

		/** onContentReady */
        public onContentReady(): void {
            this.init();
		}

		/** init content */
        private init() {

            // inicializace hodnot od rodice
            SeznamGrafDefiniceDesigner.SeznamGrafDefiniceDesignerInit(this);

			this.setTitle();
			this.createMenuButtons();
            this.createGrid();
            this.createMenuBar();
			this.createSidebar();
		}

		/** nastavit titulek dialogu */
		private setTitle() {
				this.title = "jres:32131091"	//RC 32131091 : Graf
		}

		//#endregion

		//#region *** menubar ***

		private createContextBar(): MenuParams[] {
			var bar = this.setMenuButtons();
			return bar;
		}

		/**
		 * createMenuButtons
		 */
        private createMenuButtons(): void {
			this.detailButton();
			//this.seznamDoporuceneBalickyButton();
		}

		/**
		 * vytvořit menu
		 */
		private createMenuBar(): void {
			this.menuBar(this.setMenuButtons());
		}

		private setMenuButtons(): MenuParams[] {

			const bar: MenuParams[] = [];

			bar.push({
				favorite: true,
				action: this.actions.actDetail
			})

			return bar;
        }

		/**
		 * detail button
		 */
		private detailButton(): void {
			this.actions.add(new GAction({
				name: "actDetail",
				icon: "gi-detail",
				caption: "jres:32131033",			//RC 32131033 : Detail
				run: () => {
					this.openDetail();
				}
			}));
		}


		//#endregion

		//#region *** detail ***

		/**
		 * otevřít detail
		 */
        private openDetail(_new?: boolean): void {

            var newRecord = _new == null ? false : _new;

            if (Utils.isGridEmpty(this.grid)) {

                if (newRecord === true) 
                    this.showFlash("jres:32131092", "g-state-warning", 2500, "id-flash-empty-grid-detail"); //RC 32131092 : Tento typ záznamu nelze vytvářet.
			}
            else {

				var selection = this.grid.ggrid("getSelection");

                // vybraný jeden řádek
				if (selection.length === 1) {
                    var data: any = selection[0];
                    Dialogs.DetailGrafDefiniceDlg(this, { ixs_grf: data.ixs_grf, grid: this.grid, newRecord: newRecord }).done((data: any) => {
                        this.view.requestData();
					});
                }

				// vybráno více řádků
				else {
					this.showFlash("jres:32131037", "g-state-warning", 2500, "id-flash-select-more-rows-grid-detail"); //RC 32131037 : Nelze přejít na detail s více vybranými řádky.
				}
			}

		}

		//#endregion

		//#region *** grid ***

		/** vytvořit seznam - definice objektu GRIDu, navázaných událostí atd... */
		private createGrid(): void {

			//this.gridFormat = this.createGridFormat();

            this.grid = $("<div>").gautofit().appendTo(this.element);

			this.grid.ggrid({
				data: this.view,
				name: "gridSeznam",
				renderMode: "auto",										// auto, all-at-once, paged-sync, paged-async
				columnMode: "full",										// fit (defaultne by melo byt toto), full
				customClass: "ts-grid-seznam-class",
				navigationMode: "row",									// row, cell
				defaultAction: new GAction({							//obsluzna akce, ktera se spousti dbl clickem nad radkem
					name: "doubleClickGridSeznam",
					run: (ev, ctx) => {
						this.openDetail();
					}
				}),
				searchColumns: this.gridSearchColumns,
				columns: this.gridFormat,
				contextMenu: this.createContextBar(),					// contextové menu
                sort: "ixs_grf",									// řazení seznamu 
				selection: (ev, obj) => {
					this.row = obj.getSelection();
					this.refreshPanel();
				}
			});

		}

		//#endregion

		//#region *** sidebar ***

		/** vytvořit sidebar */
		private createSidebar() {
			this.removeSidebar();
			var panel = this.createPanel();
			this.sidebar = $(this.element).gsidebar({
				userSettings: this.userSettings,
				right: {
					pinned: true,
					panels: [panel]
				}
			});
		}

		/** odstranit sidebar */
		private removeSidebar() {
			if (this.sidebar !== undefined) {
				this.sidebar.gsidebar("removeAll");
			}
		}

		/**  vytvořit panel */
		private createPanel(): GSideBarPanelOptions {
			this.panelId = "panelNahledSeznam";
			let panel = {
				minWidth: 300,
				id: this.panelId,
				caption: "jres:32131038",							//RC 32131038 : Náhled
				leaf: "jres:32131038",								//RC 32131038 : Náhled
				icon: "gi-nahled",
				open: (ev, obj) => {
					this.refreshPanel($(ev.target))
				},
			} as GSideBarPanelOptions;
			return panel;
		}

		/** refresh panelu */
		private refreshPanel(elementPanel?: JQuery<HTMLElement>): void {

			var panel: JQuery<HTMLElement> | undefined;

			if (this.closed) {		// ošetření zavření contentu
				return;
			}

			if (this.sidebar !== undefined) {
				panel = this.sidebar.gsidebar("getPanel", this.panelId);
			}
			else {
				panel = elementPanel;
			}
			if (panel !== undefined) {
				if (this.panelElement !== undefined) {
					this.panelElement.remove();
				}
				this.panelElement = $("<div>").appendTo(panel);
				GridUtils.setPanelGrid("jres:32131039", this.row, this.gridFormat, this.panelElement); //RC 32131039 : Seznam
			}
		}

		//#endregion

	}

}